// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"723":"3728e31f","854":"c44dce3f"}[chunkId] + ".chunk.js";
};